<app-crud 
  title="Product"
  [form]="form"
  [list]="list"
  [listTemplate]="listTemplate"
  [formTemplate]="formTemplate"
  (save)="save()"
  (remove)="remove($event)"
  >  
</app-crud>

<ng-template #formTemplate>
  <form [formGroup]="form" class="product-form"> 
    <mat-form-field appearance="outline">
      <mat-label>Product</mat-label>
      <input matInput formControlName="name">
    </mat-form-field>

    <mat-form-field appearance="outline">
        <mat-label>Category</mat-label>
        <mat-select formControlName="idCategory">
          <mat-option *ngFor="let category of categories" [value]="category.id" >
            {{category.name}}
          </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Short Description</mat-label>
      <input matInput formControlName="shortDescription">
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Description</mat-label>
      <textarea matInput formControlName="description"></textarea>
    </mat-form-field>
  </form>
</ng-template>

<ng-template #listTemplate let-data>
  <div class="product-item">
    {{data.name}} | {{data.category.name}}
    <div class="short-description">
      {{data.shortDescription}}
    </div>

    <div class="description">
      {{data.description}}

    </div>
  </div>